module.exports = __webpack_public_path__ + "static/img/msg-min3.22583bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/box/msg-min3.png
// module id = unO9
// module chunks = 1